import { isDirectMessageQuest } from 'lib/directMessages'

// Quests
const isQuestOwner = (user, quest) => user && quest && user.id === quest.user_id
// Every reply thread in a direct message belongs to the message's author, but
// owning one grants no thread controls there (the server refuses them).
const amQuestOwner = quest =>
    !isDirectMessageQuest(quest) && isQuestOwner(window.gon?.currentUser, quest)
const isContentModerator = user => !!(user?.knov_admin || user?.admin)
const amContentModerator = () => isContentModerator(window.gon?.currentUser)
// Knovigator staff. A few owner-only rows (a video's Download) open to them too.
const isKnovAdmin = user => !!user?.knov_admin
const amKnovAdmin = () => isKnovAdmin(window.gon?.currentUser)

const isTeamAdmin = (user, team) => user && team && team.admin_id === user.id
const amTeamAdmin = team => isTeamAdmin(window.gon?.currentUser, team)

const isQuestAdmin = (user, quest) => isTeamAdmin(user, quest?.team)
const amQuestAdmin = quest => isTeamAdmin(window.gon?.currentUser, quest?.team)

const isThreadModeratorForQuest = (user, quest) => {
    const parentQuestUserId =
        quest?.parent_quest_user_id || quest?.parent_quest?.user_id || quest?.parent?.quest?.user_id
    return !!user && !!parentQuestUserId && parentQuestUserId === user.id
}

const canDeleteQuest = (user, quest) =>
    isQuestOwner(user, quest) ||
    isContentModerator(user) ||
    isQuestAdmin(user, quest) ||
    isThreadModeratorForQuest(user, quest)

const canArchiveQuest = canDeleteQuest

const isPublic = quest => (quest?.public || quest?.team?.public) && !quest?.private

// Answers
const isAnswerOwner = (user, answer) => user && answer && user.id === answer.user_id
const amAnswerOwner = answer => isAnswerOwner(window.gon?.currentUser, answer)

const canEditAnswer = (user, answer) => isAnswerOwner(user, answer)

const canArchiveAnswer = (user, answer, quest) =>
    isAnswerOwner(user, answer) ||
    isContentModerator(user) ||
    (answer?.quest_id === quest?.id && (isQuestOwner(user, quest) || isQuestAdmin(user, quest)))

const canDeleteAnswer = (user, answer, quest) => canArchiveAnswer(user, answer, quest)

export default {
    // Quests
    isQuestOwner,
    amQuestOwner,
    isContentModerator,
    amContentModerator,
    isKnovAdmin,
    amKnovAdmin,
    canDeleteQuest,
    isTeamAdmin,
    amTeamAdmin,
    isQuestAdmin,
    amQuestAdmin,
    isThreadModeratorForQuest,
    isPublic,
    canArchiveQuest,

    // Answers
    amAnswerOwner,

    canEditAnswer,
    canArchiveAnswer,
    canDeleteAnswer,
}
